export default "__VITE_ASSET__KGFGN6v6__"